<template>
<div class="chapter">
<div class="inner_page">
<div id="d57691ac4acf6-d1e454"><span id="pagevii">
<h2 class="acknowledgements-head">ACKNOWLEDGMENTS</h2>
<p class="acknowledgements-text">Ernest Hemingway once said, ‘Writing, at its best, is a lonely life.’ And yet, this novel would never have made it into your hands without the help and encouragement of so many generous people. I’d like to thank<span id="Y_Anchor"> my amazing team:</span></p>
<p class="acknowledgements-text-indented">My family – husband, Barry Talley and daughters Laura Geyer and Sarah Glass – who support me every day in every way, even when I’m completely lost in ‘Marcialand.’</p>
<p class="acknowledgements-text-indented">Crime writer, Kate Charles, for teaching the master class at St Hilda’s College in Oxford, England, where the seed of this novel was sown.</p>
<p class="acknowledgements-text-indented">Friend and colleague, author Sarah Shaber, who told me a story at the Sisters in Crime writing retreat in Charlotte, North Carolina that changed everything.</p>
<p class="acknowledgements-text-indented">Wally and Hannah Pickworth, who let me hang out at their Eastern Shore cottage on Butcher Creek in Virginia where the plot for this novel was cooked up over crab cakes and wine.</p>
<p class="acknowledgements-text-indented">Jeannine Wayson, realtor with Coldwell Banker in Annapolis, Maryland, who in no way resembles any of the characters in this book, but if she did, she’d be dangerous.</p>
<p class="acknowledgements-text-indented">W. Edward Hudgins (‘Judge Hudge’) for help navigating and interpreting historic court records.</p>
<p class="acknowledgements-text-indented">Linda Sprenkle, fellow adventurer, location scout and long-time friend.</p>
<p class="acknowledgements-text-indented">My colleagues in the Writers’ Circle in Hope Town, Abaco, Bahamas and to my partners in crime back in Annapolis, Maryland – Becky Hutchinson, Mary Ellen Hughes, Debbi Mack, Sherriel Mattingly, Shari Randall and Bonnie Settle – once again, for tough love.</p>
<p class="acknowledgements-text-indented">And, as always, to Vicky Bijur.</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106519_epub_ack.vue?dc4a05b0